<template>
  <div class="encontrarOrcamento">
    <el-button @click="getListaOrcamento()" size="mini" type="primary">Encontrar Orçamento</el-button>

    <!-- DIALOG -->
    <el-dialog title="Encontrar Orçamento SGE" :visible.sync="dialogOrcamentoVisible">
      <el-row type="flex" justify="left">
        <el-col :xs="24" :sm="24" :md="20" :lg="22" :xl="20">
          <el-form :inline="true" :model="formPesquisa" class="form-inline-pesquisa">
            <el-form-item label="Número de Negócio:">
              <el-input v-model="formPesquisa.pesquisa" placeholder="Pesquisa por...">
                <el-button slot="append" @click="onSubmitPesquisa" icon="el-icon-search"></el-button>
              </el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
  
      <el-table :data="gridData" highlight-current-row @current-change="handleCurrentChangeTable" v-loading="loading2" element-loading-text="Loading..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.7)"  empty-text="Sem dados!">
        <!-- <el-table-column property="id" label="id" width="150" ></el-table-column> -->
        <el-table-column property="NUMERO_NEGOCIO" label="Número do Negócio" width="160"></el-table-column>
        <!-- <el-table-column property="numero" label="Versão"></el-table-column> -->
        <el-table-column property="RAZAO_SOCIAL" label="Razão Social"></el-table-column>
        <el-table-column property="NOME_FANTASIA" label="Nome Fantasia"></el-table-column>
        <el-table-column property="DPES_CODIGO" label="Cód. Cliente" width="110"></el-table-column>
      </el-table>

      <el-pagination style="margin-top:15px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="prev, pager, next"
        background
        :total="total"
      ></el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";

// const url = 'http://'+window.location.hostname+':8000/api';
const url = '/api';
export default {
  data() {
    return {
      gridData: [],
      loading2: true,
      dialogOrcamentoVisible: false,
      total: 0,
      pageSize: 20,
      currentPage: 1,
      formPesquisa: {
        pesquisa: "",
      },
    };
    
  },
  methods: {
    getListaOrcamento(com_em, ps) {
     this.loading2 = true;
      this.dialogOrcamentoVisible = true;
      if (typeof com_em === "undefined") {
        com_em = 0;
        ps = this.pageSize;
      }
      axios
        .get(url+"/negocio/" + com_em + "/" + ps + "/", {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((resp) => {
          if (resp.data.status == "Token is Expired" || resp.data.status == "Token is Invalid" || resp.data.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.loading2 = false;
            this.gridData = resp.data["dados"];
            // console.log(this.gridData);
            this.total = resp.data["total"];
            this.list = this.gridData.map((item) => {
              return {
                id: item.ID,
                numero_negocio: item.NUMERO_NEGOCIO,
                dpes_codigo: item.DPES_CODIGO,
                razao_social: item.RAZAO_SOCIAL,
                nome_fantasia: item.NOME_FANTASIA,
                dt_geracao: item.DT_GERACAO,
              };
            });
          }
        })
        .catch((err) => {
          this.$notify({
            title: "Erro",
            message: "Erro ao acessar os dados de Negócio!" + err,
            type: "error",
          });
        });
    },
    //PESQUISA
    onSubmitPesquisa() {
      this.loading2 = true;
      // let dados = {
      //   pesquisa: this.formPesquisa.pesquisa,
      // };
      // axios
      //   .post(url+"/negocio/0/" + this.pageSize, dados, {
      axios
        .get(url+"/negocio/0/" + this.pageSize + "/" + this.formPesquisa.pesquisa, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((response) => {
          this.gridData = response.data["dados"];
          this.total = response.data["total"];
          this.loading2 = false;
         /* this.list = this.gridData.map((item) => {
            return {
              id: item.id,
              ncm: item.ncm,
              descricao: item.descricao.substr(0, 70),
            };
          });*/
          this.currentPage = 1;
          this.loading = false;
        })
        .catch((err) => {
          this.list = "erro" + err;
        });
    },
    //FIM PESQUISA
    //PAGINAÇÃO
    handleSizeChange: function (size) {
      this.pageSize = size;
      let comeca_em;
      if (this.currentPage == 1) {
        comeca_em = 0;
      } else {
        comeca_em = (this.currentPage - 1) * this.pageSize;
      }

      this.getListaOrcamento(comeca_em, this.pageSize);
    },

    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      let comeca_em;
      if (currentPage == 1) {
        comeca_em = 0;
      } else {
        comeca_em = (currentPage - 1) * this.pageSize;
      }
      this.getListaOrcamento(comeca_em, this.pageSize);
    },

    //FIM PAGINAÇÃO

    handleCurrentChangeTable(val) {
      this.currentRow = val;
      this.$emit('negocio-click',this.currentRow);
      this.dialogOrcamentoVisible=false;
    },
  }
};
</script>
<style scoped>
.form-inline-pesquisa {
  margin-top: 15px;
  text-align: left;
  padding-left: 50px;
}
</style>